/**
 * Scroll Reveal Animations
 * Handles subtle fade-in and slide-up animations as elements enter the viewport.
 */
document.addEventListener('DOMContentLoaded', () => {
  const mainContent = document.getElementById('MainContent');
  if (!mainContent) return;

  // Check if we are on the product page
  const isProductPage = mainContent.getAttribute('data-template')?.startsWith('product');
  if (!isProductPage) return;

  // Fallback for browsers without IntersectionObserver support
  if (!('IntersectionObserver' in window)) {
    console.warn('[ScrollReveal] IntersectionObserver not supported in this browser.');
    return;
  }

  // Find all sections on the page
  const sections = document.querySelectorAll('.shopify-section');

  const revealObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const target = entry.target;
        target.classList.add('revealed');

        // Reveal staggered children (if any)
        const staggeredChildren = target.querySelectorAll('.reveal-stagger-item, .reveal-zoom-item');
        staggeredChildren.forEach((child, index) => {
          child.style.transitionDelay = `${index * 0.08}s`;
          child.classList.add('revealed');
        });

        // Reveal heading
        const headings = target.querySelectorAll('.reveal-heading-item');
        headings.forEach(heading => {
          heading.classList.add('revealed');
        });

        observer.unobserve(target);
      }
    });
  }, {
    root: null,
    rootMargin: '0px 0px -100px 0px', // Trigger 100px before element hits the viewport bottom
    threshold: 0.05 // Trigger when at least 5% of the element is visible
  });

  sections.forEach(section => {
    // Check if the section contains grid/multicolumn elements to stagger
    const staggerContainers = section.querySelectorAll(
      '.grid, .multicolumn-list, .stitch-trust-badges, .product-media-gallery, .slideshow, .swiper-wrapper'
    );

    if (staggerContainers.length > 0) {
      // Add stagger classes to items
      const items = section.querySelectorAll(
        '.grid__item, .multicolumn-list__item, .card, .stitch-trust-badge-img, .stitch-trust-badge-item, .stitch-video-container, .stitch-video-info, .hotspot, .slideshow__slide, .swiper-slide'
      );
      items.forEach(item => {
        if (item.classList.contains('stitch-video-container') || item.classList.contains('product-media-gallery')) {
          item.classList.add('reveal-zoom-item');
        } else {
          item.classList.add('reveal-stagger-item');
        }
      });

      // Add reveal class to headings
      const headings = section.querySelectorAll('h1, h2, h3, .section-heading, .stitch-video-heading');
      headings.forEach(heading => {
        heading.classList.add('reveal-heading-item');
      });

      section.classList.add('reveal-section-container');
      revealObserver.observe(section);
    } else {
      // For simple sections, just animate the main elements inside
      const mainElements = section.querySelectorAll(
        '.section-padding, [class*="-padding"], .stitch-video-wrapper, .product__media-wrapper, .product__info-wrapper, .rich-text__blocks'
      );

      if (mainElements.length > 0) {
        mainElements.forEach(el => {
          if (el.classList.contains('product__media-wrapper') || el.classList.contains('stitch-video-wrapper')) {
            el.classList.add('reveal-zoom-item');
          } else {
            el.classList.add('reveal-item');
          }
          revealObserver.observe(el);
        });
      } else {
        section.classList.add('reveal-item');
        revealObserver.observe(section);
      }
    }
  });
});
